import PropTypes from 'prop-types';
import React from 'react';

const ClusterMarker = ({numPoints}) => {
  return (
    <div className="map-marker cluster">
      <div className="point">{numPoints}</div>
    </div>
  );
};

ClusterMarker.propTypes = {
  numPoints: PropTypes.number.isRequired
}

export default ClusterMarker;



// WEBPACK FOOTER //
// ./src/components/solds/sold-map/cluster-marker.js